import { Form, Formik, Field } from 'formik'
import React, { useState, useCallback, useEffect } from 'react'
import { useModal } from 'react-modal-hook'
import { useDispatch, useSelector } from 'react-redux'
import Loading from 'custom/assets/loaders/Loading'
import Modal from '../../components/Modal/Modal'
import NeoButton from '../../components/NeoButton/NeoButton'
import NeoInput from '../../components/NeoInput/NeoInput'
import * as Yup from 'yup'
import { useHistory } from 'react-router-dom'
import InputError from '../../components/InputError/InputError'
import StatementIcon from 'custom/assets/accounts/Statement.svg'
import moment from 'moment'
import { getCurrentAccDetailsSelector } from '../../store/selectors/app.selector'
import PortfolioService from '../../services/portfolio.service'
import LayoutWithOutAccountCard from '../Layout/layout-without-card'
import {BIStatementSchema} from "../../schemas/downloadCenter"
import validationConfig from 'custom/config/validation.config.json'
const biStatementConfig = validationConfig['downloadCenter']['biStatement']
import { BI_STATEMENT_KEYS, BUTTON_KEYS ,VALIDATION_KEYS} from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function BiStatement(waitCondition = true) {
  const [accountDetails, setAccountDetails] = useState([])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [stage, setStage] = useState(0)
  const [reportList, setReportList] = useState([])
  const formatList = ['xlsx', 'pdf']
  const history = useHistory()
  const { t } = useTranslation()

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <h6>{error}</h6>
        <div className='mt-4 col-6 mx-auto'>
          <NeoButton
            type='button'
            mode='newDesign'
            text={t(BUTTON_KEYS.CLOSE)}
            onClick={() => {
              hideModal()
              history.push('/dashboard')
            }}
          />
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    getAccountDetails()
    getListOfFormat()
  }, [])

  const getAccountDetails = useCallback(
    async (values) => {
      try {
        const response = await PortfolioService.getAccountDetails({ ...values, fetchSavings: true })
        if (response.status === 200) {
          setAccountDetails(response.data['accountSummaryList'])
          setStage(1)
        }
      } catch (err) {
        // setError(err.error)
        setStage(1)
        // //showModal()
      }
    },
    [showModal],
  )
  const getDownload = useCallback(
    async (values) => {
      try {
        setLoading(true)
        const reqParams = {
          ...values,
          accountNo: values.accountNo,
        }
        await PortfolioService.biStatement(reqParams)
        setLoading(false)
      } catch (err) {
        setLoading(false)
        setError(err.error)
        //showModal()
      }
    },
    [showModal, accountDetails],
  )

  const getListOfFormat = useCallback(async () => {
    try {
      const response = await PortfolioService.getListOfFormat()
      if (response.status === 200) {
        setLoading(false)
        setReportList(response.data['formatList'])
        setStage(1)
      }
    } catch (err) {}
  }, [])

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderReceiptsViewForm()
      default:
        return renderLoading()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReceiptsViewForm() {
    return (
      <div>
        <Formik
          initialValues={{
            accountNo: '',
            fromDate: '',
            toDate: '',
            format: '',
            reportName: '',
          }}
          validationSchema={BIStatementSchema}
          onSubmit={getDownload}>
          {({ isSubmitting, errors, touched, handleChange, values }) => (
            <Form>
              <div className='row'>
                <div className='form-group col-12'>
                  <label className='control-label'>{t(BI_STATEMENT_KEYS.ACCOUNT_NO)} {biStatementConfig['isAccountNoRequired'] ? '*' : ''}</label>
                  <Field
                    as='select'
                    className='form-control'
                    name='accountNo'
                    disabled={loading}
                    placeholder={t(BI_STATEMENT_KEYS.SELECT_ACCOUNT_NO)}>
                    <option disabled value='' />
                    {waitCondition ? (
                      accountDetails.map((item, index) => (
                        <option key={index} value={item.accountNo}>
                          {item.accountNo}
                        </option>
                      ))
                    ) : (
                      <option disabled value='' />
                    )}
                  </Field>
                  <InputError text={errors.accountNo} touched={touched.accountNo} />
                </div>
                <div className='form-group col-6'>
                  <NeoInput
                    text={t(BI_STATEMENT_KEYS.FROM_DATE)}
                    showAsterisk={biStatementConfig['isFromDateRequired']}
                    name='fromDate'
                    type='date'
                    disabled={loading}
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                    //value={values.fromDate}
                  />
                  <InputError text={errors.fromDate} touched={touched.fromDate} />
                </div>
                <div className='form-group col-6'>
                  <NeoInput
                    text={t(BI_STATEMENT_KEYS.TO_DATE)}
                    showAsterisk={biStatementConfig['isToDateRequired']}
                    name='toDate'
                    type='date'
                    disabled={loading}
                    onChange={handleChange}
                    max={moment(new Date()).format('YYYY-MM-DD')}
                    //value={values.toDate}
                  />
                  <InputError text={errors.toDate} touched={touched.toDate} />
                </div>
                <div className='form-group col-6'>
                  <NeoInput
                    mode='select'
                    text={t(BI_STATEMENT_KEYS.FORMAT)}
                    showAsterisk={biStatementConfig['isFormatRequired']}
                    name='format'
                    disabled={loading}
                    onChange={handleChange}
                    keyValue={null}
                    list={formatList}
                  />
                  <InputError text={errors.format} touched={touched.format} />
                </div>

                <div className='form-group col-6'>
                  <NeoInput
                    mode='select'
                    text={t(BI_STATEMENT_KEYS.REPORT_NAME)}
                    showAsterisk={biStatementConfig['isReportNameRequired']}
                    name='reportName'
                    disabled={loading}
                    onChange={handleChange}
                    keyValue={null}
                    list={reportList}
                  />
                  <InputError text={errors.reportName} touched={touched.reportName} />
                </div>
              </div>
              <div className='mt-3'>
                {loading ? (
                  renderLoading()
                ) : (
                  <NeoButton type='submit' text={t(BUTTON_KEYS.DOWNLOAD)} mode='newDesign' />
                )}
              </div>
              <div className='back-cancel-style' onClick={() => history.goBack()}>
               {BUTTON_KEYS.CANCEL}
              </div>
            </Form>
          )}
        </Formik>
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='BI' showEmptySpace={true} keyPath={'BI_STATEMENT'}>
      <div className='heading-style'>{t(BI_STATEMENT_KEYS.HEADER)}</div>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithOutAccountCard>
  )
}
